import type { WorkOrderVersionSeasonData } from 'gql/graphql';
import { formatNumberToRu } from 'utils';
import { ColoredColumnTitle } from 'utils/tableCells';

import { useMemo } from 'react';

export const useWorkOrderVersionOthersSeasonsColumns = (seasons: WorkOrderVersionSeasonData[]) =>
    useMemo(
        () =>
            seasons?.map((item, index: number) => {
                const { id, year } = item;
                const isOddSeason = !(index % 2);

                return {
                    id,
                    seasonId: id,
                    accessor: `Сезон ${year}`,
                    title: (
                        <ColoredColumnTitle isOdd={isOddSeason} align="center">{`Сезон ${year}`}</ColoredColumnTitle>
                    ),
                    withoutPadding: true,
                    columns: [
                        {
                            title: (
                                <ColoredColumnTitle isOdd={isOddSeason} align="left">
                                    Объем
                                </ColoredColumnTitle>
                            ),
                            accessor: `seasonVolume_${id}`,
                            width: 112,
                        },
                        {
                            title: (
                                <ColoredColumnTitle isOdd={isOddSeason} align="right">
                                    СТОИМОСТЬ, руб. без НДС
                                </ColoredColumnTitle>
                            ),
                            accessor: `seasonValue_${id}`,
                            className: `seasonValue_${id}`,
                            align: 'right',
                            width: 124,
                            renderCell: (row: any) => <span>{formatNumberToRu(row[`seasonValue_${id}`], 2)}</span>,
                        },
                    ],
                };
            }),
        [seasons],
    );
